<template>
  <div>
    <loading-spinner
      v-if="loadingStatus"
      custom-id="history-loading-spinner"
      :loading-status="true"
    />
    <div v-else>
      <div
        v-if="items && items.length"
        class="history d-flex flex-column"
      >
        <HistoryItem
          v-for="(item, index) in items"
          :key="index"
          :item="item"
          :index="index"
          :show-action="showActions"
        />
      </div>
      <span v-else-if="accountId">No history items to show</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LoadingSpinner from '@/components/LoadingSpinner'
import HistoryItem from './HistoryItem'

export default {
  name: 'History',
  components: {
    HistoryItem,
    LoadingSpinner
  },
  props: {
    items: Array,
    showActions: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getLoadingStatus'
    }),
    ...mapState({
      accountId: state => state.templateBuilder.accountId
    }),
    loadingStatus () {
      return this.$store.getters.getLoadingStatusItem('set_template_history')
    }
  }
}
</script>

<style lang="scss" scoped>
div.history {
  margin-top: 13px;
}
</style>
